/**
 * DataSource: Câmeras (M5)
 * ------------------------
 * Hoje: nada — POC mostra placeholder "aguardando integração TCal+Axis".
 * Futuro: espelhar o app existente da TCal/Axis (Telles: "espelhar este
 *         aplicativo no módulo de câmeras para evitar complexidades
 *         iniciais de conexões direto com as câmeras").
 *
 * Importante: a POC mantém o componente de seleção de câmera +
 * captura de screenshot funcionando (mock URL), porque o M3 Via 2
 * exige captura de tela ao acionar (R-D04).
 */

import type { DamId } from '@/domain';
import type { DataSourceMeta } from './types';

export interface Camera {
  id: string;
  damId: DamId;
  codigo: string;          // 'CAM-01', 'CAM-CRISTA-S'
  label: string;
  posicao: string;         // 'Crista sul', 'Pé jusante'
  streamUrl: string | null;
  thumbnailUrl: string | null;
  isOnline: boolean;
}

export interface CamerasDataSource extends DataSourceMeta {
  list(damId?: DamId): Promise<Camera[]>;
  /** Captura de tela usada pelo M3 Via 2 (R-D04). POC retorna data URL placeholder. */
  capture(cameraId: string): Promise<{ url: string; capturedAt: Date }>;
}

const MOCK_CAMERAS: Camera[] = [
  { id: 'cam-01', damId: '' as DamId, codigo: 'CAM-01', label: 'Crista Norte',  posicao: 'Crista — norte',  streamUrl: null, thumbnailUrl: null, isOnline: false },
  { id: 'cam-02', damId: '' as DamId, codigo: 'CAM-02', label: 'Crista Sul',    posicao: 'Crista — sul',    streamUrl: null, thumbnailUrl: null, isOnline: false },
  { id: 'cam-03', damId: '' as DamId, codigo: 'CAM-03', label: 'Pé Jusante',    posicao: 'Pé — jusante',    streamUrl: null, thumbnailUrl: null, isOnline: false },
  { id: 'cam-04', damId: '' as DamId, codigo: 'CAM-04', label: 'Talude Direito', posicao: 'Talude direito', streamUrl: null, thumbnailUrl: null, isOnline: false },
];

export const mockCameras: CamerasDataSource = {
  mode: 'mock',
  pendingIntegration: {
    owner: 'TCal + Axis',
    name: 'Espelho do app de câmeras',
    status: 'pendente',
    description:
      'Telles: "Existe um aplicativo das câmeras. A ideia é espelhar este aplicativo no ' +
      'módulo de câmeras para evitar complexidades iniciais de conexão direta com as câmeras." ' +
      'Aguardando login + URL do app TCal/Axis.',
  },

  async list() {
    return MOCK_CAMERAS;
  },

  async capture(cameraId) {
    // POC: retorna data URL de placeholder. M3 Via 2 grava esta URL
    // em `tarp_records.camera_screenshot_url` como prova de captura.
    return {
      url: `placeholder:camera-${cameraId}-${Date.now()}`,
      capturedAt: new Date(),
    };
  },
};

// TODO[INTEGRACAO-TCAL-AXIS]: receber do TI da TCal:
//   1. URL do app de câmeras (provavelmente iframe embed)
//   2. SSO ou credencial técnica
//   3. Endpoint de captura de frame (se existir)
// → criar `tcalAxisCameras: CamerasDataSource` com mode='integrated'.
